import { Amortizacao, AmortizacaoSobre, AmortizacaoViewModel, DateViewModel, type EventosFinanceiros } from 'common/genericTypes';
import { Moment } from 'moment';
import { typedAction } from 'store/modules/base';
import { Option, selectOption } from 'common/genericOptions';

enum Liquidacao {
  Dmenos2 = 'D-2',
  Dmenos1 = 'D-1',
  Dzero = 'D-0',
  Dmais1 = 'D+1',
  Dmais2 = 'D+2',
}

export const liquidacaoOptions: Option[] = [
  selectOption,
  ...Object.values(Liquidacao)?.map((value) => ({
    value,
    description: value,
  })),
];

export const percentualAmortizacaoOptions: Option[] = [
  selectOption,
  {
    value: AmortizacaoSobre.Principal,
    description: 'Principal',
  },
  {
    value: AmortizacaoSobre.SaldoDevedor,
    description: 'Saldo Devedor',
  },
];

export const eventosInitialState: EventosFinanceiros = {
  datasPagamentoJuros: [],
  percentualAmortizacaoPassivelAlteracao: false,
  percentualAmortizacaoSobre: AmortizacaoSobre.Principal,
  amortizacoes: [],
  datasIncorporacaoJuros: [],
  resgateAntecipadoFacultativo: false,
};

export interface State {
  eventos: EventosFinanceiros;
}

export interface Field {
  name: keyof EventosFinanceiros;
  value: number | boolean | string | undefined | null | Moment | Moment[] | Amortizacao;
}

export const updateField = (field: Field) => {
  return typedAction('cri/eventos/UPDATEFIELD', field);
};

export const updateEventos = (eventos: EventosFinanceiros) => {
  return typedAction('cri/eventos/UPDATE', eventos);
};

export const resetEventos = () => {
  return typedAction('cri/eventos/RESET');
};

export const updateDatasPagamentoJuros = (dates: DateViewModel[]) => {
  return typedAction('cri/eventos/datasPagamentoJuros/UPDATE', dates);
};

export const updateDatasIncorporacaoJuros = (dates: DateViewModel[]) => {
  return typedAction('cri/eventos/datasIncorporacaoJuros/UPDATE', dates);
};

export const updateAmortizacoes = (amortizacoes: AmortizacaoViewModel[]) => {
  return typedAction('cri/eventos/amortizacoes/UPDATE', amortizacoes);
};

export type EventosAction = ReturnType<
  | typeof updateField
  | typeof updateEventos
  | typeof resetEventos
  | typeof updateDatasPagamentoJuros
  | typeof updateDatasIncorporacaoJuros
  | typeof updateAmortizacoes
>;
